<template>
  <div>
    <div class="poll-card">
      <div class="poll-container">
        <img
        :src="
            poll.poll_attach
              ? poll.poll_attach.file
                ? poll.poll_attach.file
                : poll.poll_attach[0]
              : 'https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/no-image.png'
          "
          class="poll-image"
          alt="poll_image"
        />
        <div :style="{ marginTop: '24px' }">
          <div class="poll-tag" :style="{ background: getPrimary50Color() }">
            <font-awesome-icon
              size="sm"
              class="mr-1"
              :style="{ color: getPrimaryColor() }"
              :icon="['fas', 'poll']"
            />
            <p class="poll-tag-text" :style="{ color: getPrimaryColor() }">
              Poll
            </p>
          </div>
        </div>
        <p class="poll-title">{{ poll.poll_question }}</p>
        <div v-if="showPercent|| poll.choices.some((i)=> i.my_vote === true)" :style="{padding: '16px 0px', paddingBottom: '0px'}">
          <div class="polloptions" v-for="option in poll.choices" :key="option.id">
            <div
              class="polloption p-0"
              :style="{
                cursor: 'auto'
              }"
            >
              <div
                class="polloption"
                v-if="option.choice_vote"
                :style="{
                  background: lighten(getPrimaryColor(), 50),
                  maxWidth: option.choice_vote + '%',
                  cursor: 'auto'
                }"
              />
              <span class="poll-option">{{ option.poll_option }}</span>
              <span class="percentage"
                >{{ option.choice_vote.toFixed(0) }} %</span
              >
            </div>
          </div>

          <div class="d-flex justify-content-between w-100">
            <p :style="{ color: getPrimaryColor() }">
              Thank you for your Answer
            </p>
            <p>Total Votes : {{ poll.total_vote }}</p>
          </div>
        </div>
        <div v-else :style="{padding: '16px 0px', paddingBottom: '0px'}">
          <div class="polloptions" v-for="option in poll.choices" :key="option.id">
            <div @click="()=>submitPollResponse(option.id)" class="polloption">
              {{ option.poll_option }}
            </div>
          </div>
        </div>
        <p class="poll-attempts">
          This poll has been taken {{poll.no_of_attempts}} times.
        </p>
      </div>
      <!-- <div class="row">
        <div class="col-md-6 col-sm-12">
          <img
            :style="{ height: '200px' }"
            :src="
              poll.poll_attach
                ? poll.poll_attach.file
                  ? poll.poll_attach.file
                  : poll.poll_attach[0]
                : 'https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/no-image.png'
            "
            class="article-image"
          />
        </div>
        <div
          class="col-md-6 col-sm-12 d-flex flex-column justify-content-between"
        >
          <div>
            <span>{{ poll.poll_question }}</span>
          </div>
          <div :style="{ 'font-weight': 'bold' }" class="mt-2">
            {{ poll.user ? poll.user.display_name : "Dovemed" }}
          </div>
          <div
            class="post-physician p-1 pl-2 pr-2 mt-2 mb-2"
            v-if="poll.user_role === 'doctor'"
            :style="{ color: 'white !important', 'font-size': '12px' }"
          >
            PHYSICIAN ({{ poll.user.speciality }})
          </div>
          <div
            v-if="poll.user && poll.tags"
            class="post__tags"
            :style="{ 'margin-left': '0px' }"
          >
            <div
              v-for="(tag, index) in poll.tags.slice(0, 2)"
              :key="index"
              class="tags"
              :style="{
                color: getSecondaryColor(),
                background: getAlphaPrimaryColor()
              }"
            >
              #{{ tag }}
            </div>
            <div v-if="poll.tags.length > 2" class="popover-button">
              <a-popover placement="right">
                <template slot="content">
                  <p
                    v-for="(tag, index) in poll.tags.slice(2)"
                    :key="index"
                    :style="{
                      color: getSecondaryColor(),
                      background: getAlphaPrimaryColor(),
                      padding: '2px'
                    }"
                  >
                    #{{ tag }}
                  </p>
                </template>
                <a-button
                  :style="{
                    background: getAlphaPrimaryColor(),
                    color: getSecondaryColor()
                  }"
                  >+{{ poll.tags.length - 3 }}
                </a-button>
              </a-popover>
            </div>
          </div>

          <div class="d-flex align-items-center flex-wrap mt-4">
            <div class="mb-2">
              This poll has been taken {{ poll.no_of_attempts }} times.
            </div>
            <div>
              <a
                class="mr-4 mb-1"
                @click="() => $refs.sharePostModal.show(poll, 5, 'Share Poll')"
                :style="{ color: getPrimaryColor() }"
                ><i
                  :style="{ color: getPrimaryColor(), 'margin-right': '2px' }"
                  class="fa fa-share-alt"
                  aria-hidden="true"
                ></i>
                SHARE</a
              >
              <a-button
                class="dovemed-button font-white primary-button"
                :style="{ background: getPrimaryColor() }"
                @click="
                  $router.push({
                    name: 'ResourceView',
                    params: { type: 'poll', id: poll.id }
                  })
                "
                >TAKE POLL</a-button
              >
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <SharePostModal ref="sharePostModal" /> -->
  </div>
</template>

<script>
//import SharePostModal from "../../../Modals/SharePost";
import { faPoll } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory";
import { eventBus } from "../../../../main";

const ResourceRepository = RepositoryFactory.get("resource");

library.add(faPoll);

export default {
  name: "PollTabView",
  props: {
    pollData: Object
  },
  // components: {
  //   SharePostModal
  // },
  data() {
    return {
      poll: null,
      showPercent: false,
    };
  },

  created() {
    this.poll = this.pollData;
  },

  methods: {
    lighten(col, amt) {
      var usePound = false;

      if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
      }

      var num = parseInt(col, 16);

      var r = (num >> 16) + amt;

      if (r > 255) r = 255;
      else if (r < 0) r = 0;

      var b = ((num >> 8) & 0x00ff) + amt;

      if (b > 255) b = 255;
      else if (b < 0) b = 0;

      var g = (num & 0x0000ff) + amt;

      if (g > 255) g = 255;
      else if (g < 0) g = 0;

      return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    },
    submitPollResponse(choice) {
      const data = {
        user_circle: this.currentCircle.id,
        user: this.authUser.user.id,
        poll: this.poll.id,
        choice: choice
      };
      ResourceRepository.postPoll(data)
        .then(res => {
          this.$notification.success({
            message: "Success",
            description: "Poll submitted successfully."
          });
          eventBus.$emit("refresh-resource-view");
          this.showPercent = true;
          ResourceRepository.getpoll(
            this.poll.id,
            1,
            5,
            this.currentCircle.id
          ).then(res => {
            console.log(res, "new poll data");
            this.poll = res.data.data.data[0];
          });
        })
        .catch(err => console.error(err));
    }
  }
};
</script>

<style lang="scss" scoped>
/* .dovemed-button {
  padding: 10px 32px !important;
} */
.poll-card {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(60, 60, 60, 0.1);
  margin-bottom: 16px;
}

.poll-container {
  padding: 16px;
}

.poll-image {
  width: 100%;
  height: 424px;
  object-fit: contain;
  @media only screen and (max-width: 700px) {
    height: 165px;
  }
}

.poll-tag-background {
  width: 54px;
  height: 22px;
  border-radius: 4px;
  opacity: 0.3;
}

.poll-tag {
  padding: 3px 8px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
}

.poll-tag-text {
  font-family: "Lato";
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  margin-bottom: 0;
  margin-left: 4px;
}

.poll-title {
  font-family: "Lato";
  font-weight: 700;
  font-size: 20px;
  color: #000000;
  padding-top: 8px;
  margin: 0px;
  line-height: 30px;
}

.poll-attempts {
  font-family: "Lato";
  font-weight: 400;
  font-size: 16px;
  color: #647490;
  margin: 0px;
}

.polloptions {
  width: 100%;
  .polloption {
    position: relative;
    cursor: pointer;
    height: 55px;
    background-color: #F1F5F9;
    padding: 1rem;
    border-radius: 10px;
    margin-bottom: 1rem;
    .poll-option {
      position: absolute;
      left: 1rem;
      top: 1rem;
    }
    .percentage {
      position: absolute;
      right: 20px;
      top: 1rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/resources/previews/PollCard.vue